import { useMemo } from "react";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import { PANEL_SET_CODES } from "shared/utils/standard-product";

export function useProductType(
  standardProduct: CategoryStandardProduct | undefined,
) {
  const isNotAccesoire = useMemo(() => {
    if (!standardProduct) return false;

    // Determine if the product type is not "accessoire" or "montageservice"
    return (
      standardProduct.productType.code !== "accessoire" &&
      standardProduct.productType.code !== "montageservice"
    );
  }, [standardProduct]);

  const isSet = useMemo(() => {
    if (!standardProduct) return false;
    return PANEL_SET_CODES.includes(standardProduct.code);
  }, [standardProduct]);

  return { isNotAccesoire, isSet };
}
